export const openAddFormFilePicker = (selectedType, onFileSelected) => {
  const input = document.createElement("input");
  const cleanup = () => input.remove();

  input.type = "file";
  input.accept = "application/pdf";
  input.onchange = async (event) => {
    try {
      await onFileSelected(event.target.files?.[0] || null, selectedType);
    } finally {
      cleanup();
    }
  };
  input.addEventListener("cancel", cleanup, { once: true });

  document.body.appendChild(input);
  input.click();
};
